import { IconX } from '@tabler/icons-react';
import React, { useEffect, useState } from 'react'
import { Modal } from 'react-bootstrap';
import TableComponent from '../../../components/DataTable/TableComponent';
import { urlApi } from '../../../api/url.api';
import { getApi } from '../../../api/call.api';
import { loadingHide, loadingShow } from '../../../loadingUi/loading.controller';
import { toast } from 'sonner';
import { dateTimeConverter } from '../../../utils/dateTimeConverter';

const RewardListOfUserModal = ({ userData }) => {
    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const [activePage, setActivePage] = useState(1);
    const [perPage, setPerPage] = useState(10);
    const [tableData, setTableData] = useState({
        data: [],
        totalCount: 0
    });

    function handlePageChange(page) {
        setActivePage(page);
    }

    function handlePerRowsChange(newPerPage, page) {
        setActivePage(page);
        setPerPage(newPerPage)
    }

    const getList = async () => {
        loadingShow();
        let resp = await getApi(urlApi.rewardListOfUser + userData?._id + "?page=" + activePage + "&limit=" + perPage);
        loadingHide();
        if (resp.responseCode === 200) {
            setTableData({
                data: resp.data?.items,
                totalCount: resp.data?.count
            });
            handleShow();
        } else {
            setTableData({
                data: [],
                totalCount: 0
            })
            toast.error(resp?.message)
        }
    }

    useEffect(() => {
        if (show) {
            getList();
        }
        return () => {

        };
    }, [activePage, perPage]);

    const columns = [
        { name: "Sl. No", center: "true", width: "60px", selector: (row) => row?._id, cell: (row, index) => (activePage - 1) * perPage + (index + 1) },
        {
            name: "Clicks", center: "true", selector: (row) => row?.linkClicks, cell: (row) => (
                <p className=''>{row?.linkClicks}</p>
            ),
        },
        { name: "Amount", center: "true", selector: (row) => row?.amountEarned, cell: (row) => "₹ " + row?.amountEarned || "0", }, {
            name: "Reward Rate", center: "true", selector: (row) => row?.rewardRate, cell: (row) =>
                <p>{row?.rewardRate}</p>
        }, {
            name: "Created", center: "true", selector: (row) => row?.createdAt, cell: (row) =>
                <p>{dateTimeConverter(row?.createdAt)}</p>
        },

    ]

    return (
        <div>
            <button className='bg-green-700 !px-5 !py-1.5 rounded-full text-sm text-white' onClick={getList}>Earnings</button>
            <Modal show={show} onHide={handleClose} size='xl' >
                <Modal.Body className='rounded-xl'>
                    <div className="flex justify-between items-center">
                        <p className="text-md font-semibold"> Rewards Of {userData?.name}</p>
                        <IconX className='cursor-pointer' onClick={handleClose} />
                    </div>
                    <hr className='my-3' />
                    <TableComponent
                        columns={columns}
                        data={tableData.data}
                        totalRows={tableData.totalCount}
                        isPagination={true}
                        handlePageChange={(e) => handlePageChange(e)}
                        handlePerRowsChange={(newPerPage, page) => handlePerRowsChange(newPerPage, page)} />

                </Modal.Body>
            </Modal>
        </div>
    )
}

export default RewardListOfUserModal